// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import echarts from 'echarts'
import axios from 'axios';
import hasDirective from '../directive/has.js'
import icpDirectives from '../directive/interceptor.js'
import '../static/css/icon.css'
import '../static/js/drag.js'
import moment from 'moment';
// 导入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import format from './utils/format.js';
// Vue.prototype.format = format
// 注册富文本组件
Vue.use(VueQuillEditor)


axios.defaults.baseURL = 'https://ctjdwx.cdqingyang.gov.cn'
Vue.prototype.$axios = axios


Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(ElementUI, {
    size: 'small'
});

// 时间格式化
Vue.filter('moment', function (value, formatString) {
    formatString = formatString || 'YYYY-MM-DD hh:mm:ss';
	return moment(value).format(formatString);
});

Vue.directive("has", hasDirective);
Vue.use(icpDirectives)
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title} | 艾特社群`;
    const role =  window.sessionStorage.getItem('ms_username');
    if (!role && to.path !== '/login') {
        next('/login');
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js